import React, { useEffect } from "react";

const RadioInput = ({ 
    label, 
    values, 
    onChange, 
    name, 
    value, 
    direction = "column",
    variant = "default"
}) => {
    const isArray = Array.isArray(values);
    const displayValues = isArray ? values : Object.keys(values);
    const firstValue = isArray ? values[0] : values[displayValues[0]]; // Get the first value

    // Ensure initialization on mount
    useEffect(() => {
        if (value === null || value === undefined) {
            onChange({ target: { name, value: firstValue } });
        }
    }, [value, firstValue, name, onChange]);

    const handleChange = (selectedValue) => {
        onChange({ target: { name, value: selectedValue } });
    };

    const containerClass = () => {
        switch (variant) {
            case "radio-box":
                return "radio-box-container";
            case "radio-item":
                return "radio-item-container";
            default:
                return "";
        }
    };

    const labelClass = (optionValue) => {
        switch (variant) {
            case "radio-item":
                return `radio-item ${String(value) === String(optionValue) ? "selected" : ""}`;
            default:
                return `radio-option ${String(value) === String(optionValue) ? "selected" : ""}`;
        }
    };

    return (
        <div className="uk-child-width-1-1 uk-child-width-1-3@m uk-flex uk-grid uk-grid-small uk-margin-small-bottom">
            <div>
                <label className="uk-form-label uk-display-block">{label}:</label>
            </div>

            <div className="uk-width-2-3@m">
                <div
                    className={`dimension-input-container radio-input-container ${containerClass()}`}
                    style={{
                        borderRadius: variant === "radio-box" ? "10px" : "0",
                        padding: variant === "radio-box" ? "10px" : "0",
                        backgroundColor: variant === "radio-box" ? "#F6F7F9" : "transparent"
                    }}
                >
                    <div
                        className="radio-button-group"
                        style={{
                            display: "flex",
                            flexDirection: direction === "row" ? "row" : "column",
                            gap: "10px",
                            width: "100%"
                        }}
                    >
                        {displayValues.map((item, index) => {
                            const optionValue = isArray ? item : values[item];
                            return (
                                <label
                                    key={index}
                                    className={labelClass(optionValue)}
                                    style={{
                                        padding: variant === "radio-item" ? "10px" : "5px",
                                        backgroundColor: variant === "radio-item" ? "#F6F7F9" : "transparent",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        flex: direction === "row" ? "1" : "initial",
                                        minWidth: 0
                                    }}
                                >
                                    <input
                                        type="radio"
                                        id={`${name}-${index}`}
                                        name={name}
                                        value={optionValue}
                                        checked={String(value) === String(optionValue)}
                                        onChange={() => handleChange(optionValue)}
                                        className="mobile-cat-radio"
                                        style={{ marginRight: "20px" }}
                                    />
                                    <span>{isArray ? item : item}</span>
                                </label>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RadioInput;
